import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
/*Recharts 2.0.8 uses ResizeDetector which uses ResizeObserver which is not supported by IE
This import can be removed once we update the Recharts version to 2.0.9 or higher*/
import 'resize-observer-polyfill/dist/ResizeObserver.global';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { configureReduxStore, initialApplicationState } from './redux';

import { App } from './app';

declare global {
	interface Window {
		initialReduxState: () => void;
		__REDUX_DEVTOOLS_EXTENSION__: () => any;
		// eslint-disable-next-line
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: ({}: any) => any;
	}
}

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') || '';

const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState || initialApplicationState;
const store = configureReduxStore(history, initialState);

const rootElement = document.getElementById('root') as HTMLElement;

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>,
	rootElement
);

//registerServiceWorker();
export default store;
